class MenuStateChooser {
  constructor() {
    this.shouldCloseMenu();
  }

  cookieName() {
    return `keep_menu_closed`;
  }

  saveState(state) {
    document.cookie = `${this.cookieName()}=${$(state).hasClass('open') ? 'true' : 'false'}; path=/`;
  }

  keepOpened() {
    const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + this.cookieName().replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return $(matches)[1] == 'true' || $(matches)[1] == undefined;
  }

  shouldCloseMenu() {
    if (this.keepOpened()) {
      $('#sidebar-menu-wrapper').addClass('open');
    } else {
      $('#sidebar-menu-wrapper').removeClass('open');
    }
  }
}

export default MenuStateChooser;